<template>
  <div :class="{ 'show': popoverShow, 'animate': animate }">
    <div class="bottomPopupMask" @click="triggerClose" :class="{ 'show': popoverShow, 'animate': animate }"></div>
    <div class="bottomPopup" :class="{ 'show': popoverShow, 'animate': animate }" style="bottom: 0;z-index: 10002;">
      <div class="bottomPopupTitle">
        <div class="inner">{{ title }}</div>
        <div class="bottomPopupTitleClose" @click="triggerClose">
          <img class="icon" src="https://resource.rcclchina.com.cn/wechatMiniProgram/invoice/iconPopupClose.png" alt=""/>
        </div>
      </div>
      <div class="bottomPopupContent">
        <slot></slot>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: "BottomPopup",
  props: {
    title: {
      type: String,
      default: '标题'
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      popoverShow: false,
      animate: false,
      animationData: {},
      isShow:false
    }
  },
  watch: {
    'show': function (val) {
      if (val) {
        this.showCon()
      } else {
        this.close()
      }
    }
  },
  methods: {
    triggerClose() {
      this.$emit('close')
    },
    showCon () {
      this.popoverShow= true
      setTimeout(() => {
        this.animate = true
      }, 50)
    },
    close () {
      this.animate = false
      setTimeout(() => {
        this.popoverShow = false
      }, 300)
    },
  }
}
</script>
<style scoped lang="less">
.bottomPopupMask {
  width: 100%;
  display: none;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 10001;
  opacity: 0;
  background-color: rgba(0, 0, 0, 0.6);
  transition: opacity .3s;
}
.bottomPopupMask.show,
.bottomPopup.show {
  display: block;
}
.bottomPopupMask.animate {
  opacity: 1;
}
.bottomPopup {
  display: none;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2000;
  background-color: #fff;
  transition: all .3s;
  transform: translateY(100%);
  border-radius: 10px 10px 0 0;
}
.bottomPopup.animate {
  transform: translateY(0);
}

.bottomPopupTitle {
  position: relative;
  //height: 22px;
  padding: 13px 30px;
  text-align: center;
  font-size: 16px;
  color: #282828;
  line-height: 22px;
}
.bottomPopupTitle .inner {
  padding: 0 5px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.bottomPopupTitleClose {
  position: absolute;
  top: 13px;
  right: 13px;
  height: 20px;
  width: 20px;
  padding: 3.5px;
}
.bottomPopupTitleClose .icon {
  display: block;
  height: 13px;
  width: 13px;
}
.bottomPopupContent {
  //padding: 0 15px 17px;
}
</style>